export default {
  duration: {
    shortest: '100ms',
    shorter: '150ms',
    short: '200ms',
    standard: '250ms',
    complex: '350ms',
  },
}
